import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { LutienUsersGetByIdResponseDTO } from './dto/lutien-users.getById.response.dto';
import { getAuthToken } from '@src/services/auth-service';

export class LutienUsersService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/users`, client.getTimeout());
  }

  async getById(request: { id: string; settings?: RetrySettings }): Promise<LutienUsersGetByIdResponseDTO> {
    return (
      await this.client.get<LutienUsersGetByIdResponseDTO>(
        `${request.id}`,
        {},
        {
          bearerToken: await getAuthToken(),
          settings: request.settings,
        },
      )
    ).data;
  }
}
